import React from 'react';
import Lottie from 'react-lottie';
import './Fire_Lottie.css';
import * as animationData from './Fire_Lottie.json';

const Fire_Lottie = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <>
            <section className='main'>
                <div className='Fire_Lottie_icon'>
                    <Lottie className="me-auto"
                        options={defaultOptions}    
                    />
                </div>
            </section>
        </>
    )
}

export default Fire_Lottie
